import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import React from 'react'
import { useTranslate } from '@tolgee/react';
import { colors } from '../../Assets/styles/colors'

const CloseQcConfirmation = ({ open, handleClose, handleRemove }) => {
    const { t } = useTranslate();
    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"

        >
            <DialogTitle id="alert-dialog-title" style={{ background: colors.background, color: colors.chatElementColor }}>{t('general.warning')}</DialogTitle>
            <DialogContent style={{ background: colors.background }}>
                <DialogContentText id="alert-dialog-description" style={{ color: colors.chatElementColor }}>
                    {t('quick_chat.caution_close_qc')}
                </DialogContentText>
            </DialogContent>
            <DialogActions style={{ background: colors.background }}>
                <Button onClick={handleClose}>  {t('general.cancel')}</Button>
                <Button style={{ color: "red" }} onClick={handleRemove} autoFocus>
                    {t('general.close')}
                </Button>
            </DialogActions>
        </Dialog >
    )
}

export default CloseQcConfirmation